"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Grid_1 = __importDefault(require("@mui/material/Grid"));
const dashboardContainer_1 = __importDefault(require("./dashboardContainer"));
const dashboardTable_1 = __importDefault(require("./dashboardTable"));
const overview_1 = __importDefault(require("./overview"));
const spendOverTime_1 = __importDefault(require("./spendOverTime"));
const DashboardPage = () => {
    return ((0, jsx_runtime_1.jsx)(dashboardContainer_1.default, { children: (0, jsx_runtime_1.jsxs)(Grid_1.default, { container: true, children: [(0, jsx_runtime_1.jsx)(Grid_1.default, { size: {
                        xs: 12,
                        md: 4.5,
                        lg: 4.5,
                    }, children: (0, jsx_runtime_1.jsx)(overview_1.default, {}) }), (0, jsx_runtime_1.jsx)(Grid_1.default, { size: {
                        xs: 12,
                        md: 7.5,
                        lg: 7.5,
                    }, children: (0, jsx_runtime_1.jsx)(spendOverTime_1.default, {}) }), (0, jsx_runtime_1.jsx)(Grid_1.default, { size: {
                        xs: 12,
                        md: 12,
                        lg: 12,
                    }, children: (0, jsx_runtime_1.jsx)(dashboardTable_1.default, {}) })] }) }));
};
exports.default = DashboardPage;
